import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { useHistory } from "react-router-dom";


import { FormControl, Checkbox, InputLabel, Select, MenuItem, CircularProgress, Typography } from '@mui/material';

import {
    InputAdornment,
    Box,
    Paper,
} from "@mui/material";

// Ícones
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // Banco
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"; // Conta
import LocationCityIcon from "@mui/icons-material/LocationCity"; // Agência
import BusinessIcon from "@mui/icons-material/Business"; // Unidade
import DescriptionIcon from "@mui/icons-material/Description"; // Descrição
import { Divider, List, ListItem, ListItemText } from "@mui/material";
import {

    ListItemAvatar,
    Avatar,

} from "@mui/material";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import EventIcon from "@mui/icons-material/Event";
import PersonIcon from "@mui/icons-material/Person";

import api from '../../../../../services/api';

import { Radio, RadioGroup, FormControlLabel, Stack } from "@mui/material";



export default function Extrato({ instituicaoBancaria }) {

    const [checkReceitas, setCheckReceitas] = useState(false);
    const [checkDespesas, setCheckDespesas] = useState(false);
    const [menorData, setMenorData] = useState("");
    const [maiorData, setMaiorData] = useState("");
    const [buscaNome, setBuscaNome] = useState("");


  // formata valor para Real brasileiro, previne valor null
const formatCurrency = (valor) => {
    const numero = valor ?? 0; // se valor for null ou undefined, usa 0
    return numero.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
};
    const formatDate = (dataISO) => {
        if (!dataISO) return "";
        const [year, month, day] = dataISO.split("T")[0].split("-");
        return `${day}/${month}/${year}`;
    };


    const history = useHistory();

    const [loading, setLoading] = useState(true);
    const [extrato, setExtrato] = useState([]);
    const [extratoHoje, setExtratoHoje] = useState([]);

    const [objeto, setObjeto] = useState([]);
    const today = new Date();

    const isToday = (data) => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const todayString = `${yyyy}-${mm}-${dd}`;

        // compara só a string
        return data === todayString;
    };





    function returnDescricaoFornecedor(fornecedor) {
        try {
            if (!fornecedor) return "Fornecedor não informado";

            const identificacao = fornecedor.tipo_fornecedor === 0 ? "CPF" : "CNPJ";
            const valor = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf || "N/A" : fornecedor.cnpj || "N/A";
            const nome = fornecedor.tipo_fornecedor === 0
                ? `${fornecedor.nome || ""} ${fornecedor.sobrenome || ""}`.trim()
                : fornecedor.nome_fantasia || "N/A";

            return `${nome} | ${identificacao}: ${valor}`;
        } catch (e) {
            console.error("Erro em returnDescricaoFornecedor:", e, fornecedor);
            return "Fornecedor inválido";
        }
    }

    function returnDescricaoCliente(cliente) {
        try {
            if (!cliente) return "Cliente não informado";

            const identificacao = cliente.tipo_cliente === 0 ? "CPF" : "CNPJ";
            const valor = cliente.tipo_cliente === 0 ? cliente.cpf || "N/A" : cliente.cnpj || "N/A";
            const nome = cliente.tipo_cliente === 0
                ? `${cliente.nome || ""} ${cliente.sobrenome || ""}`.trim()
                : cliente.nome_fantasia || "N/A";

            return `${nome} | ${identificacao}: ${valor}`;
        } catch (e) {
            console.error("Erro em returnDescricaoCliente:", e, cliente);
            return "Cliente inválido";
        }
    }

    function returnDescricaoIb(ib) {
        try {
            if (!ib) return "Instituição Bancária não informada";

            return `Banco: ${ib.banco || "N/A"} | Agência: ${ib.agencia || "N/A"} | Conta: ${ib.conta || "N/A"}`;
        } catch (e) {
            console.error("Erro em returnDescricaoIb:", e, ib);
            return "Instituição Bancária inválida";
        }
    }

    function returnDescricaoPagador(p) {
        try {
            if (!p) return "Pagador não informado";

            if (p.tipo_pagador === 0) {
                return returnDescricaoCliente(p.cliente_pagador);
            } else if (p.tipo_pagador === 1 || p.tipo_pagador === 2) {
                return returnDescricaoIb(p.instituicao_bancaria_pagador);
            }

            return "Tipo de pagador desconhecido";
        } catch (e) {
            console.error("Erro em returnDescricaoPagador:", e, p);
            return "Pagador inválido";
        }
    }

    function returnDescricaoRecebedor(p) {
        try {
            if (!p) return "Recebedor não informado";

            if (p.tipo_recebedor === 0) {
                return returnDescricaoCliente(p.cliente_recebedor);
            } else if (p.tipo_recebedor === 1) {
                return returnDescricaoIb(p.instituicao_bancaria_recebedor);
            } else if (p.tipo_recebedor === 2) {
                return returnDescricaoFornecedor(p.fornecedor_recebedor);
            }

            return "Tipo de recebedor desconhecido";
        } catch (e) {
            console.error("Erro em returnDescricaoRecebedor:", e, p);
            return "Recebedor inválido";
        }
    }






    async function listarInformacoes() {
        try {
            const token = Cookies.get("token");
            const headers = { Authorization: "Bearer " + token };
            const regra = Cookies.get("regra");

            if (regra.includes("ADMIN")) {
                let response = await api.get(
                    `v1/protected/financeiro/instituicaobancaria/extrato/${instituicaoBancaria.id_instituicao_bancaria}`,
                    { headers }
                );

                const dados = response.data;
                setObjeto(dados);

                // 🔹 Filtra somente status = 1 (pago)
                const pagos = dados.pagamentos.filter((p) => p.status === 1);


                // 🔹 Processa para virar extrato
                // 🔹 Processa para virar extrato
                const extratoFormatado = pagos.map((p) => {
                    let valorAjustado = p.valor;
                    let tipo = "";

                    if (p.tipo_pagador === 1) {
                        // Despesa → valor negativo
                        valorAjustado = -Math.abs(p.valor);
                        tipo = "DESPESA";
                    } else if (p.tipo_recebedor === 1) {
                        // Receita → valor positivo
                        valorAjustado = Math.abs(p.valor);
                        tipo = "RECEITA";
                    }

                    return {
                        id: p.id_pagamento,
                        tipo: tipo,
                        data_pagamento: p.data_pagamento,
                        hora_pagamento: p.hora_pagamento,
                        metodo_pagamento: p.metodo_pagamento,
                        quemPagou: returnDescricaoPagador(p), // depois vai virar returnDescricaoPagador(p)
                        quemRecebeu: returnDescricaoRecebedor(p), // depois vai virar returnDescricaoRecebedor(p)
                        valor: valorAjustado,
                        saldo_anterior: p.saldo_anterior,
                        saldo_posterior: p.saldo_posterior,
                    };
                });

                const extratoHoje = extratoFormatado.filter((p) => {
                    const result = isToday(p.data_pagamento);
                    console.log("Pagamento ID:", p.id, "data_pagamento:", p.data_pagamento, "isToday:", result);
                    return result;
                });

                const extratoRestante = extratoFormatado.filter((p) => {
                    const result = !isToday(p.data_pagamento);
                    console.log("Pagamento ID:", p.id, "data_pagamento:", p.data_pagamento, "isRestante:", result);
                    return result;
                });
                // 🔹 Atualiza os states
                setExtratoHoje(extratoHoje);
                setExtrato(extratoRestante);
                setLoading(false);
            }
        } catch (err) {
            console.error("Erro ao listar extrato:", err);
            setLoading(false);
        }
    }




    useEffect(() => {
        listarInformacoes();
    }, []); // <-- refaz a requisição ao mudar página ou tamanho





    const ListaPagamentos = ({ pagamentos }) => {
        return (
            <List>
                {pagamentos.map((item) => (
                    <ListItem key={item.id} divider alignItems="flex-start">
                        <ListItemAvatar>
                            <Avatar sx={{ bgcolor: item.valor < 0 ? "error.main" : "success.main" }}>
                                {item.valor < 0 ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
                            </Avatar>
                        </ListItemAvatar>

                        <ListItemText
                            primary={
                                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                                    {item.tipo} ID: {item.id} — {item.metodo_pagamento?.nome || "N/A"}
                                </Typography>
                            }
                            secondary={
                                <>
                                    {/* Data e saldo anterior */}
                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="body2" color="text.secondary">
                                            <EventIcon fontSize="small" sx={{ mr: 1, verticalAlign: "middle" }} />
                                            Data: {formatDate(item.data_pagamento)} {item.hora_pagamento}
                                        </Typography>
                                        <Typography variant="body2">
                                            <Box component="span">Saldo Anterior:</Box>{" "}
                                            <Box
                                                component="span"
                                                sx={{
                                                    fontWeight: "bold",
                                                    color: item.saldo_anterior < 0 ? "error.main" : "success.main",
                                                }}
                                            >
                                                {formatCurrency(item.saldo_anterior || 0)}
                                            </Box>
                                        </Typography>
                                    </Box>








                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        {
                                            item.valor > 0
                                                ?
                                                <Typography variant="body2" sx={{ visibility: "hidden" }}>
                                                    <PersonIcon fontSize="small" sx={{ mr: 1, verticalAlign: "middle" }} />
                                                    Pagador: {item.quemPagou || "Teste"}
                                                </Typography>
                                                :
                                                <Typography variant="body2" sx={{ visibility: "hidden" }}>
                                                    <AccountBalanceIcon fontSize="small" sx={{ mr: 1, verticalAlign: "middle" }} />
                                                    Recebedor: {item.quemRecebeu || "Teste"}
                                                </Typography>
                                        }
                                        <Typography variant="body2">
                                            <Box component="span">Valor dessa Operação:</Box>{" "}
                                            <Box
                                                component="span"
                                                sx={{
                                                    fontWeight: "bold",
                                                    color: item.valor < 0 ? "error.main" : "success.main",
                                                }}
                                            >
                                                {item.valor < 0 ? "-" : "+"} {formatCurrency(Math.abs(item.valor))}
                                            </Box>
                                        </Typography>
                                    </Box>


                                    < Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        {
                                            item.valor < 0
                                                ?
                                                <Typography variant="body2" color="text.secondary">
                                                    <PersonIcon fontSize="small" sx={{ mr: 1, verticalAlign: "middle" }} />
                                                    Quem Recebeu: {item.quemRecebeu || "Teste"}
                                                </Typography>
                                                :
                                                <Typography variant="body2" >
                                                    <PersonIcon fontSize="small" sx={{ mr: 1, verticalAlign: "middle" }} />
                                                    Pagador: {item.quemPagou || "Teste"}
                                                </Typography>
                                        }
                                        <Typography variant="body2">
                                            <Box component="span">Saldo Final:</Box>{" "}
                                            <Box
                                                component="span"
                                                sx={{
                                                    fontWeight: "bold",
                                                    color: item.saldo_posterior < 0 ? "error.main" : "success.main",
                                                }}
                                            >
                                                {formatCurrency(item.saldo_posterior || 0)}
                                            </Box>
                                        </Typography>
                                    </Box>



                                </>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        );
    };


    return (
        <>
            {
                !loading &&
                <Box
                    sx={{
                        padding: 2,
                        marginLeft: 1,
                        width: "100%",
                        backgroundColor: "#f9fbfb",
                        borderRadius: 2,
                        boxShadow: 2,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Extrato Bancário
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    <Grid container spacing={2} alignItems="flex-start">
                        {/* Coluna esquerda - cálculos */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ mb: 1 }}>
                                {/* Saldo Inicial */}
                                <Box sx={{ display: "flex", mb: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: "black", mr: 1 }}>
                                        Saldo Inicial:
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: "bold",
                                            color: objeto.saldo_inicial < 0 ? "error.main" : "success.main",
                                        }}
                                    >
                                        {formatCurrency(objeto.saldo_inicial)}
                                    </Typography>
                                </Box>

                                {/* Entradas */}
                                <Box sx={{ display: "flex", mb: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: "black", mr: 1 }}>
                                        Entradas:
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: "bold",
                                            color: objeto.total_receitas < 0 ? "error.main" : "success.main",
                                        }}
                                    >
                                        {formatCurrency(objeto.total_receitas)}
                                    </Typography>
                                </Box>

                                {/* Saídas */}
                                <Box sx={{ display: "flex", mb: 0.5 }}>
                                    <Typography variant="body2" sx={{ color: "black", mr: 1 }}>
                                        Saídas:
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: "bold",
                                            color: "error.main",
                                        }}
                                    >
                                        {formatCurrency(objeto.total_despesas)}
                                    </Typography>
                                </Box>

                                {/* Saldo Final */}
                                <Box sx={{ display: "flex" }}>
                                    <Typography variant="body2" sx={{ color: "black", mr: 1 }}>
                                        Saldo Final:
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: "bold",
                                            color: objeto.saldo_final < 0 ? "error.main" : "success.main",
                                        }}
                                    >
                                        {formatCurrency(objeto.saldo_final)}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        {/* Coluna direita - filtros */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ mb: 1 }}>
                                {/* Linha 1 - Receitas/Despesas */}
                                <Stack direction="row" spacing={2} alignItems="center" mb={1}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={checkReceitas}
                                                onChange={() => setCheckReceitas(!checkReceitas)}
                                                color="primary"
                                            />
                                        }
                                        label="Receitas"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={checkDespesas}
                                                onChange={() => setCheckDespesas(!checkDespesas)}
                                                color="secondary"
                                            />
                                        }
                                        label="Despesas"
                                    />
                                </Stack>

                                {/* Linha 2 - Datas e Buscar */}
                                <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
                                    <TextField
                                        label="De"
                                        variant="outlined"
                                        size="small"
                                        value={menorData}
                                        onChange={(e) => setMenorData(e.target.value)}
                                        placeholder="DD/MM/YYYY"
                                        inputProps={{ pattern: "[0-9/]*" }}
                                    />

                                    <TextField
                                        label="Até"
                                        variant="outlined"
                                        size="small"
                                        value={maiorData}
                                        onChange={(e) => setMaiorData(e.target.value)}
                                        placeholder="DD/MM/YYYY"
                                        inputProps={{ pattern: "[0-9/]*" }}
                                    />

                                    <TextField
                                        label="Buscar"
                                        variant="outlined"
                                        size="small"
                                        value={buscaNome}
                                        onChange={(e) => setBuscaNome(e.target.value)}
                                        placeholder="Nome..."
                                    />
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>


                    <Divider sx={{ mb: 1 }} />


                    <Typography style={{ fontSize: 12 }} gutterBottom>
                        Hoje
                    </Typography>

                    <ListaPagamentos pagamentos={extratoHoje} />

                    <Divider sx={{ mb: 3 }} />

                    <Typography style={{ fontSize: 12 }} gutterBottom>
                        Anterior
                    </Typography>

                    <ListaPagamentos pagamentos={extrato} />
                    <Divider sx={{ mb: 1 }} />

                    {/* Saldo Inicial alinhado à direita */}
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: "normal", color: "black", mr: 1 }}>
                            Saldo Inicial:
                        </Typography>
                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{
                                fontWeight: "bold",
                                color: objeto.saldo_inicial < 0 ? "error.main" : "success.main",
                            }}
                        >
                            {formatCurrency(objeto.saldo_inicial)}
                        </Typography>
                    </Box>
                </Box>


            }
        </>

    );
}


